import { useState } from 'react';

const faqList = [
  {
    q: 'Как понять, что обучение сотрудников эффективно?',
    a: 'Эффективность определяется по четырём уровням модели Киркпатрика: реакция участников, усвоение знаний, изменение поведения и бизнес-результат. Реальная эффективность подтверждается на уровнях 3 и 4 — когда сотрудник меняет поведение и это отражается на KPI компании.',
  },
  {
    q: 'Что такое ROI корпоративного обучения?',
    a: 'ROI (Return on Investment) обучения — это отношение финансовой отдачи от обучения к затратам. Формула: (Финансовый результат - Затраты) / Затраты × 100%. Например, если обучение стоило 10 000 BYN, а дополнительная прибыль составила 50 000 BYN, ROI = 400%. Каждый вложенный рубль принёс 4 рубля прибыли.',
  },
  {
    q: 'Как измерить эффективность корпоративного тренинга?',
    a: 'Замер проводится в три этапа: 1) зафиксировать базовые KPI до тренинга, 2) провести обучение с практикой и домашними заданиями, 3) через 1-3 месяца повторно замерить те же KPI и сравнить. Разница в цифрах — это измеримый эффект от обучения.',
  },
  {
    q: 'Какие KPI использовать для оценки обучения?',
    a: 'Ключевые KPI делятся на три группы. Бизнес-KPI: конверсия, средний чек, длина сделки, повторные продажи, NPS. HR-KPI: текучесть, скорость адаптации, вовлечённость. Операционные KPI: количество ошибок, скорость обработки заявок, процент выполнения плана. Выбор конкретных метрик зависит от целей обучения.',
  },
  {
    q: 'Можно ли оценить эффективность Soft Skills обучения?',
    a: 'Да, Soft Skills поддаются оценке, но требуют комплексного подхода. Используются: оценка 360 градусов до и после обучения, наблюдение руководителя, опросы коллег и клиентов, бизнес-метрики (снижение числа конфликтов, рост CSI, сокращение времени согласования).',
  },
  {
    q: 'Когда проводить повторную оценку эффективности?',
    a: 'Рекомендуется проводить повторную оценку через 1-3 месяца после обучения. Этого времени достаточно для закрепления новых навыков в поведении. Для сложных управленческих навыков — до 6 месяцев. Важно замерять в одинаковых условиях, чтобы исключить сезонные искажения.',
  },
  {
    q: 'Кто должен оценивать эффективность обучения?',
    a: 'Это совместная задача: HR организует процесс и собирает данные, руководитель сотрудника наблюдает за изменением поведения и KPI, бизнес-тренер предоставляет методологию оценки. Ответственность за внедрение результатов лежит на руководителе.',
  },
  {
    q: 'Какие ошибки совершают HR при оценке обучения?',
    a: 'Главные ошибки: оценивать только реакцию участников, не делать замеры до обучения, не согласовывать KPI с бизнес-целями, не подключать руководителей, оценивать знания, а не поведение, не анализировать ROI, не предоставлять бизнесу обратную связь по результатам обучения.',
  },
  {
    q: 'Как обучение влияет на прибыль компании?',
    a: 'Обучение влияет на прибыль через несколько каналов: рост конверсии продаж на 10-30%, увеличение среднего чека, сокращение цикла сделки, снижение ошибок, снижение текучести (экономия на подборе и адаптации), ускорение онбординга новичков, рост производительности труда и вовлечённости.',
  },
  {
    q: 'Можно ли оценить эффективность онлайн-обучения?',
    a: 'Да, онлайн-обучение оценивается по тем же принципам, что и очное. Дополнительно доступны цифровые метрики: процент завершения курса, время прохождения, результаты тестов. Главный критерий остаётся неизменным — изменение поведения и влияние на бизнес-показатели.',
  },
  {
    q: 'Как оценить работу бизнес-тренера?',
    a: 'Работа бизнес-тренера оценивается по измеримым критериям: изменение KPI участников до и после программы, обратная связь руководителей о внедрении навыков, наличие разработанных материалов (чек-листы, скрипты, алгоритмы), сопровождение после обучения и готовность к прозрачному анализу ROI.',
  },
  {
    q: 'Что делать после обучения, чтобы знания не забылись?',
    a: 'Шесть ключевых действий: домашние задания с дедлайнами, регулярная обратная связь от руководителя, интервальное повторение материала (через 2 недели и 2 месяца), внедрение чек-листов и скриптов в ежедневную работу, система наставничества, промежуточная оценка результатов.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Часто задаваемые вопросы об оценке эффективности обучения
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Ответы на ключевые вопросы об измерении результативности корпоративного обучения, ROI, KPI и модели Киркпатрика
        </p>

        <div className="space-y-4">
          {faqList.map((item, i) => (
            <div key={i} className="bg-white rounded-xl border border-gray-200 overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-5 text-left hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <span className="font-bold text-gray-900 pr-4">{item.q}</span>
                <i className={`ri-arrow-down-s-line text-xl text-teal-600 flex-shrink-0 transition-transform ${openIndex === i ? 'rotate-180' : ''}`}></i>
              </button>
              <div className={`px-6 pb-5 ${openIndex === i ? '' : 'hidden'}`}>
                <p className="text-gray-600 leading-relaxed">{item.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}